import HttpHelper from '../utils/http-helper';

export default class CompetenceModule {

	constructor() {
		this.competences = [];
		this.competencesSelected = 'allCompetences';
		this.select = document.querySelector('#competencesSelect');
		this.resetButton = document.querySelector('#competencesResetButton');
	}

	addEventListener(callerModule) {
        this.resetButton.addEventListener('click', () => {
            if (callerModule.dataTable) callerModule.dataTable.page = 1;
            if (callerModule.dataTable) callerModule.dataTable.offset = 0;
            this.resetSelect().then(callerModule.getData());
		});
		this.select.addEventListener('change', () => {
			this.competencesSelected = this.select.value;
			if (this.select.value === '') {
				this.resetButton.setAttribute('disabled', 'true');
			} else {
				this.resetButton.removeAttribute('disabled');
			}
            if (callerModule.dataTable) callerModule.dataTable.page = 1;
            if (callerModule.dataTable) callerModule.dataTable.offset = 0;
            callerModule.getData().then();
		});
	}

	async getAllData() {
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/competence?sort={"nameShort":1}`);
		this.competences = response?.data;
	}

	async resetSelect() {
		this.setAllCompetencesOption();
        await this.loadCompetences();
    }

	setAllCompetencesOption() {
        this.select.innerHTML = null;
        this.select.value = 'allCompetences';
		this.competencesSelected = 'allCompetences';
		this.resetButton.setAttribute('disabled', 'true');

        const defaultOption = document.createElement('OPTION');
        defaultOption.innerHTML = 'Alle Zuständigkeiten';
        defaultOption.value = 'allCompetences';
        this.select.appendChild(defaultOption);
	}

	loadCompetences() {
		this.setAllCompetencesOption();
		this.getAllData().then(() => {

			if (this.competences.length > 0) {
				this.competences.forEach((competences) => {
					const newOption = document.createElement('OPTION');
					newOption.innerHTML = competences.nameShort;
					newOption.value = competences._id;
					this.select.appendChild(newOption);
				});

				this.select.value = 'allCompetences';
				this.select.removeAttribute('disabled');
			}
		});
	}

}
